import { render, staticRenderFns } from "./specialPeosRecords.vue?vue&type=template&id=1d0aa34c&scoped=true&"
import script from "./specialPeosRecords.vue?vue&type=script&lang=js&"
export * from "./specialPeosRecords.vue?vue&type=script&lang=js&"
import style0 from "./specialPeosRecords.vue?vue&type=style&index=0&id=1d0aa34c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0aa34c",
  null
  
)

export default component.exports